import classnames from 'classnames';
import React, { FC } from 'react';
import { symbol as Symbol } from '@wix/santa-editor-symbols';
import { Bubble, TextLabel } from '@wix/wix-base-ui';
import { useActionsDispatcher } from '../ActionsDispatcher';
import { useUtils } from '../UtilsProvider';
import styles from './SearchButton.scss';
import type { SearchButtonProps } from './SearchButton.types';

export const SearchButton: FC<SearchButtonProps> = ({ className, buttonRef }) => {
  const { dispatchSearchButtonClick } = useActionsDispatcher();
  const { translate } = useUtils();

  return (
    <>
      <button
        ref={buttonRef}
        className={classnames(styles.searchButton, className)}
        data-hook="new-add-panel-editor-search-button"
        onClick={dispatchSearchButtonClick}
      >
        <Symbol name="editorSearchButton" />
        <TextLabel
          className={styles.searchLabel}
          value={translate('Editor_Search_Add_Panel_Search_Label')}
          ellipsisProps={{ disabled: true }}
          type="T07"
          shouldTranslate={false}
        />
        <Bubble
          className={styles.searchBubble}
          arrowAlignment="left"
          arrowStyle={{
            position: 'absolute',
            top: '14px',
            left: '-8px',
          }}
        >
          <TextLabel
            value={translate('Editor_Search_Add_Panel_Title_Text')}
            type="T03"
            enableEllipsis={false}
            shouldTranslate={false}
          />
          <TextLabel
            value={translate('Editor_Search_Add_Panel_Description_Text')}
            enableEllipsis={false}
            shouldTranslate={false}
          />
        </Bubble>
      </button>
      <hr className={styles.searchSeparator} />
    </>
  );
};
